import { computed, inject, Injectable } from '@angular/core';

import { HasPermissionsService } from '@connect-services/client/services/has-permissions.service';
import { PermissionAliasEnum } from '@connect-services/src/sdk/api';

@Injectable({
    providedIn: 'root',
})
export class MapFilterPermissionsService {
    public readonly canManage = computed(() =>
        this.hasPermissions.checkPermissions([PermissionAliasEnum.MANAGE_MAP_FILTER]),
    );
    public readonly canRead = computed(
        () => this.canManage() || this.hasPermissions.checkPermissions([PermissionAliasEnum.READ_MAP_FILTER]),
    );
    public readonly tooltipInsufficient = computed(() => (this.canManage() ? undefined : 'insufficientPermissions'));

    private readonly hasPermissions = inject(HasPermissionsService);
}
